import Box from 'UIKit/Box/Box'
import { FlexProps } from 'UIKit/Box/types'
import Button from 'UIKit/Button'
import Text from 'UIKit/Text'
import { RowCenter, RowMiddle } from 'layout/Components/Row'
import { useAuth } from 'state/auth/hooks'
import { useToggleDisplayNotification, useUnreadNotificationAmount } from 'state/notification/hooks'
import styled from 'styled-components'
import { Icons } from 'svgs'

const NotificationButton: React.FC<FlexProps> = ({ ...props }) => {
  const { unreadAmount } = useUnreadNotificationAmount()
  const { isOpened: isNotificationOpened, toggle: updateDisplayNotification } = useToggleDisplayNotification()
  const { hasSession } = useAuth()

  return (
    hasSession && (
      <RowMiddle
        {...props}
        className="notification-button-container"
        onClick={(e) => {
          e.stopPropagation()
          updateDisplayNotification(!isNotificationOpened)
        }}
      >
        <StyledNotificationIconButton variant="text">
          <StyledNotiIconContainer minWidth={36} minHeight={36} position="relative">
            <Icons.NotificationIcon />

            {unreadAmount > 0 ? (
              <StyledUnreadAmountBadge>
                <Text fontSize="12px" bold>
                  {unreadAmount}
                </Text>
              </StyledUnreadAmountBadge>
            ) : null}
          </StyledNotiIconContainer>
        </StyledNotificationIconButton>
      </RowMiddle>
    )
  )
}

const StyledNotificationIconButton = styled(Button)`
  padding: 0 !important;
`
const StyledNotiIconContainer = styled(RowCenter)`
  border-radius: 50%;
`

const StyledUnreadAmountBadge = styled(Box)`
  border-radius: ${({ theme: { radii } }) => radii.small};
  background: ${({ theme: { colors } }) => colors.strokeAlt3};
  border: ${({ theme: { colors } }) => `1px solid ${colors.background}`};

  max-height: 36px;

  position: absolute;
  top: -5px;
  right: -5px;

  padding: 2px 6px;
`

export default NotificationButton
